export default "__VITE_ASSET__BlNob0WZ__ 400w, __VITE_ASSET__C_YwEx8G__ 800w, __VITE_ASSET__CkQnpenv__ 1200w";